module.exports = "/_next/static/images/OptimizeSyncRuns-d7f319ce04db946f334803e16990d93c.webp";